export function getMixpanelProjectToken(): string {
  return process.env.REACT_APP_MIXPANEL_TOKEN!;
}

export function isDev(): boolean {
  return process.env.NODE_ENV === "development";
}

if (typeof window !== "undefined") {
  (window as any).test = "test";
  (window as any).isDev = isDev;
}
